var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coming-soon"},[_c('div',{staticClass:"coming-soon-card"},[_c('div',{staticClass:"coming-soon-eyebrow"},[_vm._v("Próximamente")]),_c('h2',{staticClass:"coming-soon-title"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"coming-soon-description"},[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }